import { render, staticRenderFns } from "./mng.vue?vue&type=template&id=04016496&"
import script from "./mng.vue?vue&type=script&lang=js&"
export * from "./mng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports